module.exports = __webpack_public_path__ + "img/Vector.0d5e6f7a.png";